<template>
    <button
        type="button"
        class="btn is-primary btn-md whitespace-no-wrap"
        :disabled="disabled"
        :title="disabled ? 'Du har redan exporterat den här listan, välj lista igen för att exportera på nytt' : ''"
        @click="exportAddressList"
    >
        Exportera
        <font-awesome-icon
            v-if="loading"
            icon="spinner"
            spin
            pulse
            class="ml-sm"
        />
    </button>
</template>

<script>
    export default {
        props: {
            addressListId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                disabled: false,
                loading: false,
            };
        },

        methods: {
            exportAddressList() {
                this.loading = true;
                this.disabled = true;
                window.location.href = route('admin.address-lists.export', this.addressListId);

                // It's too complicated to detect when the export is finished, so we don't.
                // The button will be disabled until the page is refreshed.
                setTimeout(() => this.loading = false, 3000);
            },
        },
    };
</script>
